module.exports = __webpack_public_path__ + "img/ear.3e74c23a.svg";